import { useState, useEffect } from 'react';

function isPlatformFirefox() {
  return navigator.userAgent.includes("Firefox");
}
function usePlatformFirefox() {
  const [isMatch, setIsMatch] = useState(false);
  useEffect(() => {
    setIsMatch(isPlatformFirefox());
  }, []);
  return isMatch;
}

export { isPlatformFirefox, usePlatformFirefox };
//# sourceMappingURL=platform.is-firefox.js.map
